import { FormEvent, useState } from "react";

type FormStatus = "idle" | "submitting" | "success" | "error";

export default function RegisterInterestForm() {
  const [status, setStatus] = useState<FormStatus>("idle");

  const submit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setStatus("submitting");
    const formElement = event.currentTarget;
    const form = new FormData(formElement);

    try {
      const response = await fetch("/api/register-interest", {
        method: "POST",
        headers: { "content-type": "application/json" },
        body: JSON.stringify({
          name: form.get("name"),
          email: form.get("email"),
          phone: form.get("phone"),
        }),
      });
      if (!response.ok) throw new Error(`Registration failed: ${response.status}`);
      setStatus("success");
      formElement.reset();
    } catch {
      setStatus("error");
    }
  };

  if (status === "success") {
    return (
      <p className="my-6 text-sm font-medium text-green-700" role="status">
        Thanks — we’ll let you know when it becomes available.
      </p>
    );
  }

  return (
    <form onSubmit={submit}>
      <div className="grid gap-4 grid-cols-1 my-4">
        <label className="block text-sm font-medium text-gray-700">
          <span>Name</span>
          <input
            required
            type="text"
            name="name"
            autoComplete="name"
            className="shadow-sm focus:ring-brand-500 focus:border-brand-600 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="Enter your name"
          />
        </label>
        <label className="block text-sm font-medium text-gray-700">
          <span>Email</span>
          <input
            required
            type="email"
            name="email"
            autoComplete="email"
            className="shadow-sm focus:ring-brand-500 focus:border-brand-600 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="Enter your email"
          />
        </label>
        <label className="block text-sm font-medium text-gray-700">
          <span>Phone number</span>
          <input
            required
            type="tel"
            name="phone"
            autoComplete="tel"
            className="shadow-sm focus:ring-brand-500 focus:border-brand-600 block w-full sm:text-sm border-gray-300 rounded-md"
            placeholder="Enter your phone number"
          />
        </label>
        {status === "error" ? (
          <p className="text-sm text-red-700" role="alert">
            We couldn’t register your interest. Please try again.
          </p>
        ) : null}
        <div className="flex justify-end">
          <div className="w-64">
            <button
              type="submit"
              disabled={status === "submitting"}
              className="w-full flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-brand-600 hover:bg-brand-900 disabled:cursor-wait disabled:opacity-60"
            >
              {status === "submitting" ? "Registering…" : "Register interest"}
            </button>
          </div>
        </div>
      </div>
    </form>
  );
}
